import { FC } from "react";
import { CheckCoverage } from "@/components";
import styles from "./CheckCoveragePage.module.scss";

export const CheckCoveragePage: FC = () => {
  return (
    <div className={styles.CheckCoverageContainer}>
      <CheckCoverage />
    </div>
  );
};

export default CheckCoveragePage;
